import { render, staticRenderFns } from "./QScoreCardQuilityRxCompensable.vue?vue&type=template&id=0a50bf2d&scoped=true&"
import script from "./QScoreCardQuilityRxCompensable.vue?vue&type=script&lang=js&"
export * from "./QScoreCardQuilityRxCompensable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50bf2d",
  null
  
)

export default component.exports